import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { matchPath, useLocation, useNavigate } from 'react-router-dom';
import workspaceService from '../../service/workspace.service';
import type { TreeNode } from '../../service/tree.service';
import { updateDefaultWorkspace } from '../auth/actions';
import { selectCurrentWorkspace } from '../auth/selectors';
import { consolePathFor } from './treeUtils';
import { pushRecent } from './recent';

export const switchToWorkspace = async (dispatch: any, node: TreeNode) => {
  pushRecent(node.id);
  let record: any = node;
  try {
    const list = await workspaceService.getWorkspaceList();
    const found = Array.isArray(list) ? list.find((w: any) => w.id === node.id) : null;
    if (found) record = found;
  } catch {
    // fall back to the node itself
  }
  await dispatch(updateDefaultWorkspace(record));
  const existingAuth = JSON.parse(sessionStorage.getItem('auth') || '{}');
  sessionStorage.setItem(
    'auth',
    JSON.stringify({
      ...existingAuth,
      current: { ...existingAuth.current, default_workspace: record }
    })
  );
  window.location.assign('/');
};

export const useOpenNode = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  return useCallback(
    (node: TreeNode) => {
      if (node.kind === 'workspace') {
        void switchToWorkspace(dispatch, node);
        return;
      }
      pushRecent(node.id);
      const path = consolePathFor(node);
      if (path) navigate(path);
    },
    [navigate, dispatch]
  );
};

export const useCurrentNodeId = (): number | null => {
  const { pathname } = useLocation();
  const ws: any = useSelector(selectCurrentWorkspace);
  const m = matchPath('/org/:id/*', pathname) || matchPath('/entity/:id/*', pathname);
  const id = m?.params?.id ? Number(m.params.id) : NaN;
  if (!Number.isNaN(id)) return id;
  return ws?.id ?? null;
};
